import VoilaConfig from '../config';
import axios from 'axios';

export const REQUEST_CATEGORIES = 'REQUEST_CATEGORIES';
export const RECEIVE_CATEGORIES = 'RECEIVE_CATEGORIES';

const API_CATEGORIES_URL_BACKUP = `${  VoilaConfig.API_URL}/wp/v2/genre`;
const API_CATEGORIES_MOOD_BACKUP = `${  VoilaConfig.API_URL}/wp/v2/mood`;
const API_CATEGORIES_TEMPO_BACKUP = `${  VoilaConfig.API_URL}/wp/v2/energy`;
const API_CATEGORIES_INSTRUMENT_BACKUP = `${  VoilaConfig.API_URL}/wp/v2/instrument`;
const API_CATEGORIES_URL = '/api/genre';
const API_CATEGORIES_MOOD = '/api/mood';
const API_CATEGORIES_TEMPO = '/api/energy';
const API_CATEGORIES_INSTRUMENT = '/api/instrument';

function requestCategories(json) {
  return {
    type: REQUEST_CATEGORIES
  };
}

function receiveCategories(json) {
  return {
    type: RECEIVE_CATEGORIES,
    items: json,
    receivedAt: Date.now()
  };
}

export function fetchCategories() {
  return (dispatch) => {
    dispatch(requestCategories());
        const categories = axios.get(API_CATEGORIES_URL);
        const mood = axios.get(API_CATEGORIES_MOOD);
        const energy = axios.get(API_CATEGORIES_TEMPO);
        const instrument = axios.get(API_CATEGORIES_INSTRUMENT);
        return axios.all([categories, mood, energy, instrument]).then(axios.spread((...res) => {
            var res_combined=[];
            res_combined.category=res[0].data;
            res_combined.mood=res[1].data;
            res_combined.energy=res[2].data;
            res_combined.instrument=res[3].data;
            dispatch(receiveCategories(res_combined));
         })).catch(errors => {
          const categories1 = axios.get(API_CATEGORIES_URL_BACKUP);
          const mood1 = axios.get(API_CATEGORIES_MOOD_BACKUP);
          const energy1 = axios.get(API_CATEGORIES_TEMPO_BACKUP);
          const instrument1 = axios.get(API_CATEGORIES_INSTRUMENT_BACKUP);
          axios.all([categories1, mood1, energy1, instrument1]).then(axios.spread((...res1) => {
            var res_combined1=[];
            res_combined1.category=res1[0].data;
            res_combined1.mood=res1[1].data;
            res_combined1.energy=res1[2].data;
            res_combined1.instrument=res1[3].data;
            dispatch(receiveCategories(res_combined1));
         }));
          
        });
      
  }
}


// WEBPACK FOOTER //
// ./src/actions/CategoriesActions.js